import React, { useState, useEffect } from "react";
import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import voucherwork from "./voucherwork";
import { useNavigate } from 'react-router-dom'

//var dateFormat = require('dateformat');

const RenderWpForm = () => {

const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const resturl=sessionStorage.getItem("RESTURL");

//var boolFetchingSads=false;


const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});

const [locations, setLocations] = useState([]);
const [laborcltype, setLaborcltype] = useState([]);
/*
vchrtype is set when user clicks the radio option.
switchmpr and latefee are not currently in use
*/
const [vchroptions, setVchroptions] = useState({switchmpr:0,latefee:0,vchrtype:''});


const [numcomments, setNumcomments] = useState({lc:0, wp:0});

const [userprompt, setUserprompt] = useState({msg:""});
const [email, setEmail] = useState({MESSAGE:''});

const [udak, setUdak] = useState([]);
//wptappudak.AMT_WITHOUT_DOC_NO
const [tbludaklc, setTbludaklc] = useState([]);
const [tbludakwp, setTbludakwp] = useState([]);
const [wptapp, setWptapp] = useState({WPT_APP_ID:0});

const [dowait, setDowait] = useState({show:false});
const [dlwait, setDlwait] = useState({show:false});


const [TOTAL_EMPTY_FIELDS, setTOTAL_EMPTY_FIELDS] = useState({NUM:500});






const location = useLocation();


useEffect(() => {

console.log("location.state: "+JSON.stringify(location.state));

if (!sessionStorage.getItem("IRD_LOGIN_ID")==null || sessionStorage.getItem("IRD_LOGIN_ID")=="null" || sessionStorage.getItem("IRD_LOGIN_ID")==undefined || sessionStorage.getItem("IRD_LOGIN_ID")==""){
	navigate("/dashboard");
	return;
	}//end if

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if
	
if (location.state.WPT_APP_ID){
	setWptapp({WPT_APP_ID:location.state.WPT_APP_ID});
	//getwpformoptions();
	}//end if
else
	console.log("location.state.WPT_APP_ID not provided");
	//qrylabor();
 },[]);

useEffect(() => {
//console.log("useEffect"+wptapp.WPT_APP_ID);
if (wptapp.WPT_APP_ID>0){
	
	if (udak.length==0)
		gettblwptappudak();	
	//console.log('wptapp.APP_TYPE_ID'+wptapp.APP_TYPE_ID)
	if (wptapp.REF_NUM==undefined){
		getwptapp();
		}//end func
	else if (wptapp.STATUS==null)
		setWptappStatus();
	}//end if
 },[wptapp]);

useEffect(() => {
//const newcount=1+renders.count;
//setRenders((prev)=>{return {...prev, count:newcount}});
setDowait({show:false});
 },[JSON.stringify(tbludaklc)]);
 

 useEffect(() => {
	console.log("useEffect vchroptions.vchrtype: "+vchroptions.vchrtype);
	if (vchroptions.vchrtype!=''){
		const elem=vchroptions.vchrtype+'AMT[]';
		if (document.getElementsByName(elem)[0])
			document.getElementsByName(elem)[0].focus();
		window.scrollTo(0, document.body.scrollHeight);
		}//end if

const vchrsUserPrompt=<>check if the auto-generated comments are correct.<br/>
	If not you can type corrections, then click save changes button.
	or you can click the "clear the table" icon to start over</>;
	
	if (vchroptions.vchrtype=="LC"){
		if (numcomments.lc==0)
			setUserprompt({msg:"key the voucher amounts then click save changes"});
		else
			setUserprompt({msg:vchrsUserPrompt});
		}//end if

	if (vchroptions.vchrtype=="WP"){
		if (numcomments.wp==0)
			setUserprompt({msg:"key the voucher amounts then click save changes"});
		else
			setUserprompt({msg:vchrsUserPrompt});
		}//end if
		


		
 },[vchroptions.vchrtype, numcomments]);
 
useEffect(() => {
	console.log("useEffect udak.length: "+udak.length);

if (udak.length>0)
	dosetTbludaklc();
else{
	setTbludaklc([]);
	//setTbludakwp([]);
	}//end else
	

},[JSON.stringify(udak)]);

/*
useEffect(() => {
//console.log('udak[0]: '+JSON.stringify(udak[0]));

if (udak.length>0 && tbludaklc.length>0 && tbludakwp.length>0){
	console.log('udak.NUM_LC_DOCS: '+udak[0].NUM_LC_DOCS);
	if (udak[0].NUM_LC_DOCS==0){
		$("#rdlcvchr").trigger('click');
		enableAmountInput('lc');
		document.getElementById('rdlcvchr').checked=true;
		}//end if
	else if (udak[0].NUM_WP_DOCS==0){
		enableAmountInput('wp');
		document.getElementById('rdwpvchr').checked=true;
		}//end if
	}//end if
 },[JSON.stringify(tbludaklc), JSON.stringify(tbludakwp)]);


*/

async function setWptappStatus(){

		setWptapp((prev)=>{
	return {...prev, IRD_LOGIN_ID:sessionStorage.getItem("IRD_LOGIN_ID")};
	
});
	const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID:wptapp.WPT_APP_ID, STATUS:"CHECK"} )
  };		

 await fetch(resturl+'rarwpform/setwptappstatus',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersetwptappstatus(res) )
      .catch(err => console.log(err));
	  
}//end func

function aftersetwptappstatus(res){
setWptapp((prev) => {
return {...prev
, STATUS:"CHECK"
}});
/*
, CHR_ORGL_DOCS_DATE:res[0].CHR_ORGL_DOCS_DATE
, ORGL_DOCS_USER:res[0].ORGL_DOCS_USER

*/
}//end func

async function getwpformoptions(){
	
	const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID:wptapp.WPT_APP_ID} )
  };		

  await fetch(resturl+'rarwpform/getwpformoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwpformoptions(res) )
      .catch(err => console.log(err));
	  
}//end func

function aftergetwpformoptions(res){
let templocations=[];
let templaborcltype=[];
	
res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const key2=combo+"_"+index+"_2";
	const val=col['VAL'];
	const opt=col['OPT'];
	//console.log('afterfetchctrycodes nam: '+nam);
	if (combo=='location')
		templocations.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='laborcltype')
		templaborcltype.push(<option key={key2} value={val}  >{opt}</option>);
	
	});//end map
console.log('aftergetwpformoptions templocations.len : '+templocations.length);
setLocations(templocations);
setLaborcltype(templaborcltype);
}//end func

async function getwptapp(e){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID:wptapp.WPT_APP_ID} )
  };		

 await fetch(resturl+'rarwpform/getwptapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptapp(res) )
      .catch(err => console.log(err));
	  

}//end func

function aftergetwptapp(res){

let datas=wptapp;
//datas['REF_NUM']=res[0].REF_NUM;

for(var attributename in res[0]){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
	}//end for	
	


setWptapp((prev)=>{
	return {...prev, doSectionChange:true, datas}
});

if (datas.LBR_CLR_STATUS.toUpperCase()=="APPROVED")
	document.getElementById('rdwpvchr').click();

}//end func





function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

function handleChange(e, index){
	//console.log('handleChange udak:'+JSON.stringify(udak));
	console.log('handleChange index:'+index);
	
	let tempudak=udak;
	if (e.target.name=='VCHR_COMMENT[]')
		tempudak[index].VCHR_COMMENT=e.target.value;
	else
		tempudak[index].AMOUNT=e.target.value;
	
	setUdak(tempudak);
	if (document.getElementById('btnsavevchrchanges'))
		document.getElementById('btnsavevchrchanges').style.visibility='visible';
	if (document.getElementById('btinsertprepdoc'))
		document.getElementById('btinsertprepdoc').style.visibility='hidden';
	if (document.getElementById('btnclearvchrtable'))
		document.getElementById('btnclearvchrtable').style.visibility='hidden';
	
}



function dosetTbludaklc(){
let lchtmrows=[];
let wphtmrows=[];
let lcnumcomments=0, wpnumcomments=0;
console.log('udak.length : '+udak.length);

udak.map((col, index) => {
	//console.log('dosetTbludaklc col: '+JSON.stringify(col));
	const trkey='tr_'+index;
	const tdkey='td_'+index;
	const typ=col.VCHR_TYPE;
	//console.log('vchr_type:'+typ);
	//const doclink=(col.docno==null)?<></>:<a href={"https://customsprem.gov.tc/webuploads/voucher/"+col.docno+".pdf"} target="_none" >{col.docno}</a>;
	let htmrow=[];
	htmrow.push(<tr key={trkey} >
	<td align='center'   >{col.ACCOUNT}</td>
	<td align='center'   ><input type="text" name={typ+'AMT[]'}  autoComplete='off'  defaultValue={col.AMOUNT} onChange={(e)=>{handleChange(e, index);}} onFocus={(e)=>{e.target.select();}} size="9" style={{textAlign:"right"}} /></td>
	<td align='left'   >{col.ACCT_DESCP_1}</td>
	<td align='center'   >{col.MODIFY_USER}</td>
	<td align='center'   >{col.CHR_MODIFY_DATE}</td>
	</tr>);
	
	if (udak[index].VCHR_COMMENT!=null ){
		htmrow.push(<tr key={trkey+"amt"}  >
		<td align='center' key={index+"c1"}  >&nbsp;</td>
		<td align='center' key={index+"c2"}  >&nbsp;</td>
		<td align='left'  key={index+"c3"} colSpan="3"  ><textarea name='VCHR_COMMENT[]' defaultValue={col.VCHR_COMMENT} onChange={(e)=>{handleChange(e, index);}} onFocus={(e)=>{e.target.select();}} rows="3" cols="80" ></textarea></td>
		</tr>);
		if (typ=='LC')
			lcnumcomments++;
		else
			wpnumcomments++;
	}//end if


	if (typ=='LC')
		lchtmrows.push(htmrow);
	else
		wphtmrows.push(htmrow);
});
{/*
<td align='center' colSpan="1" ><input d defaultValue={udak[index].cmt} onChange={(e)=>{handleChange(e, index);}} onFocus={(e)=>{e.target.select();}} size="110" /></td>
*/}
setTbludaklc(lchtmrows);
setTbludakwp(wphtmrows);
setNumcomments({lc:lcnumcomments, wp:wpnumcomments});
}//end func






function apptypeChange(apptypeid){
	console.log('apptypeChange: '+apptypeid);
	if (apptypeid=='')
		setUdak([]);
	else if (udak.length>0)
		savechanges();
	else {
		gettblwptappudak();
		}//end else
}//end func

function enableAmountInput(flag){
	
setVchroptions((prev)=>{
	return {...prev, vchrtype:flag}	
});

let lcelem=document.getElementsByName('LCAMT[]');
for (var i=0; i<lcelem.length; i++){
	lcelem[i].readOnly=true;
	lcelem[i].classList.add("gnsbro");
	}//end for

let wpelem=document.getElementsByName('WPAMT[]');
for (var i=0; i<wpelem.length; i++){
	wpelem[i].readOnly=true;
	wpelem[i].classList.add("gnsbro");
	}//end for
	
flag=flag.toUpperCase();
let elem=document.getElementsByName(flag+'AMT[]');
//var i=0; len=elem.length;
for (var i=0; i<elem.length; i++){
	elem[i].readOnly=false;
	elem[i].classList.remove("gnsbro");
	}//end for


}//end func




function setemailmessage(){
const msg=document.getElementsByName('emailmsg')[0].value;
setEmail((prev)=>{
	return {...prev, MESSAGE:msg}

});
}//end func



function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".trigger"))
	document.querySelector(".trigger").addEventListener("click", toggleModalsm);

if (document.querySelector(".close-button"))
	document.querySelector(".close-button").addEventListener("click", toggleModalsm);

window.addEventListener("click", windowOnClick);
}//end func




function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func


function vchroptionsChange(vchroption, e){
	if (vchroption=="latefee")
		setVchroptions((prev)=>{return {...prev,latefee:e.target.checked?1:0}});
	else if (vchroption=="switchmpr")
		setVchroptions((prev)=>{return {...prev,switchmpr:e.target.checked?1:0}});
	
	
}//end func

function callSetVchroptions(e){

const LBR_CLR_STATUS=wptapp.LBR_CLR_STATUS??"";
const PROCESS_AREA=wptapp.PROCESS_AREA??"";

/*
if (PROCESS_AREA.toUpperCase()=="GENERAL" && e.target.value=="WP" && LBR_CLR_STATUS.toUpperCase()!="APPROVED"){
	alert("Please approve the Labour Clearance first!");
	document.getElementById('rdlcvchr').checked=false;
	document.getElementById('rdwpvchr').checked=false;
	return;
	}//end if

*/
	
const [name, value]=[e.target.name, e.target.value];
console.log("callSetVchroptions name: "+name);

	setVchroptions((prev)=>{
		return {...prev, [name]:value}	
	});
	
	
/*
BFD01k1
SELECT STATUS FROM WPT_APP WHERE REF_NUM='BIC01cl'	
update BFADM.WPT_APP set STATUS='REVIEWED' WHERE REF_NUM='BIC01cl'
2025-08-29
Previously tried to block creating balance receipts if LC not approved.
Alternative approach is to allow instead of block, 
but alert supervisor to check LCs with status AWAITING APPROVAL

The voucher creation process will change STATUS to AWAITING APPROVAL if not already approved

	if (!document.getElementById('tdapprovelc').classList.contains("hidden"))
		document.getElementById('tdapprovelc').classList.add("hidden");
	
	if (value=='WP' && wptapp.IPM_LBR_CLR_APP_ID!="" && wptapp.PROCESS_AREA=="General" && wptapp.STATUS!="APPROVED"){
		if (document.getElementById('tdapprovelc').classList.contains("hidden"))
			document.getElementById('tdapprovelc').classList.remove("hidden");
		}//end if

*/		
	
}//end func



async function updatelbrclrappdecision(e){

const params={
	LBR_CLR_APP_ID: wptapp.IPM_LBR_CLR_APP_ID
	, DEC_ID: 2 //approved
	, REVERSE_REASON: ""
	, APP_STATUS_ID: 1
	, USERNAME: sessionStorage.getItem("USERNAME")
}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwptprocess/updatelbrclrappdecision',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatelbrclrappdecision(res) )
      .catch(err => console.log(err));

}//end func

function afterupdatelbrclrappdecision(res){
let UPDATE_COUNT=0;
if (res.length)
	if (res[0].UPDATE_COUNT)
		UPDATE_COUNT=res[0].UPDATE_COUNT;
	
	
if (UPDATE_COUNT>0){
	showsnackbar("application decision update done!");
	setWptapp((prev)=>{
		return {...prev, STATUS:res[0].STATUS}
		});
	
	}//end if
else
	showsnackbar("error: something went wrong");


}//end func


function backPage(e){
e.preventDefault(); 

const BACK_PAGE=location.state?(location.state.BACK_PAGE??"wptform"):"wptform";

console.log("BACK_PAGE: "+BACK_PAGE);

if (BACK_PAGE!=""){
	let temp_state=location.state;
	temp_state.WPT_APP_ID=wptapp.WPT_APP_ID;
	temp_state.shownextbutton=1;
	temp_state.SECTION="K";
	temp_state.SEQ_NO=udak[0].SEQ_NO;
	navigate("/"+BACK_PAGE, {state:temp_state});
	}//end if

/*
e.preventDefault(); navigate("/wptform", {state:{WPT_APP_ID:wptapp.WPT_APP_ID,shownextbutton:1, SEQ_NO:udak[0].SEQ_NO}});
*/	
}//end func



const IRD_LOGIN_ID=sessionStorage.getItem("IRD_LOGIN_ID");
const refnum=wptapp.REF_NUM;
const refurl=sessionStorage.getItem("UPLOADURL")+refnum+"/foto.png";
//const mpefoto=resturl+"rarwpform/getwptappfoto?path="+wptapp.REF_NUM+"/foto.png";
//console.log('mpefoto path: '+mpefoto);
//refurl+"foto.png";
//const scanslink=refurl+"scans.pdf";
let orgl_docs=(wptapp.ORGL_DOCS_DATE==null)?'':wptapp.ORGL_DOCS_USER+' '+wptapp.CHR_ORGL_DOCS_DATE;



function gettblwptappudak(){

	let params=[];
	params.push({WPT_APP_ID:wptapp.WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")});
	//params.push();
	const state={};
	const props={func:"gettblwptappudak", params:params, state:state, vchroptions:vchroptions};
	voucherwork(props, location, navigate, confirm, showsnackbar, setUdak, setDowait, setVchroptions);
	
}//end func


function getprepinsertdoc(e){
	let params=[];
	params.push({WPT_APP_ID:wptapp.WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME"), VCHR_TYPE:vchroptions.vchrtype });
	params.push({ SEQ_NO:udak[0].SEQ_NO, WPT_APP_ID:wptapp.WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")});
	//params.push();
	const state={WPT_APP_ID:wptapp.WPT_APP_ID,SCTN:'K',shownextbutton:1, SEQ_NO:udak[0].SEQ_NO, BACK_PAGE:"wptform"};
	const props={func:"getprepinsertdoc", params:params, state:state, vchroptions:vchroptions};
	voucherwork(props, location, navigate, confirm, showsnackbar, setUdak, setDowait, setVchroptions);
}//end func

function savechanges(){

	let params=[];
	params.push({
	udak:udak
	, WPT_APP_ID:wptapp.WPT_APP_ID
	, APP_TYPE_ID:wptapp.APP_TYPE_ID
	, WRK_PMT_STARTS:""
	, WRK_PMT_ENDS:""
	, SWITCH_EMPLOYER:vchroptions.switchmpr
	, LATE_FEE:vchroptions.latefee
	, USERNAME:sessionStorage.getItem("USERNAME")
	});
	//params.push();
	const state={};
	const props={func:"savechanges", params:params, state:state, vchroptions:vchroptions};
	voucherwork(props, location, navigate, confirm, showsnackbar, setUdak, setDowait, setVchroptions);
	
}//end func



function clearwptappudak(e){
e.preventDefault();
	let params=[];
	params.push({VCHR_TYPE:"LC", WPT_APP_ID:wptapp.WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")});
	//params.push();
	const state={};
	const props={func:"clearwptappudak", params:params, state:state, vchroptions:vchroptions};
	voucherwork(props, location, navigate, confirm, showsnackbar, setUdak, setDowait, setVchroptions);
	
}//end func	

	
  return (
    <>
	<p align='center' style={{marginBottom:"18px"}}>
	creating payment vouchers for {wptapp.PROCESS_AREA} Work Permit application with Ref # 
	<a href="#" title='go to application form fields' onClick={(e)=>{backPage(e);}} >{refnum}</a> 
	</p>

	  
	<table border='0' align='center' id='tblsteps'  >
	<tbody>
	<tr  key="tr_EMAIL" >
	<td align='right' >Labour Clearance Status: </td>
	<td align='left' style={{color:"brown"}} >{wptapp.LBR_CLR_STATUS??"<empty>"}</td>
	</tr>
	<tr  key="tr_CREATE_USER" >
	<td align='right' >Application Creator Name: </td>
	<td align='left' >{wptapp.WEB_USER_NAME??"APS"}</td>
	<td align='center' rowSpan="7" >
		{wptapp.REF_NUM!=undefined && <>
		<img src={resturl+"rarwpform/getwptappfoto?path="+wptapp.REF_NUM+"/foto.png"} border='0' height="150" />
		<br/>
		Applicant: {wptapp.IMG_REF+", "+wptapp.MPE_FIRST_NAME+" "+wptapp.MPE_LAST_NAME}
		</>
		}
		</td>
	</tr>
	<tr  key="tr_MPR_NAME" >
	<td align='right' >Employer: </td>
	<td align='left' >{wptapp.MPR_NAME}</td>

	</tr>
	<tr key="tr_OCCUPATION" >
	<td align='right' >Job Title: </td>
	<td align='left' >{wptapp.MPE_OCCUPATION}</td>
	</tr>
	<tr key="tr_WRK_CONTRACT" >
	<td align='right' >Contract Dates: </td>
	<td align='left' >{wptapp.CHR_WRK_CONTRACT_START+" to "+wptapp.CHR_WRK_CONTRACT_END}</td>
	</tr>
	{/*
	<tr key="tr_vchroptions" >
	<td align='right' >Options: </td>
	<td align='left' >
		<input type="checkbox" id='cblatefee' onChange={(e)=>{vchroptionsChange("latefee", e);}} title='late fee' /><label htmlFor='cblatefee' className='hand' >late fee</label>
		&nbsp;&nbsp;
		<input type='checkbox' id='cbswmpr' onChange={(e)=>{vchroptionsChange("switchmpr", e);}} title='switch of employer' /><label htmlFor='cbswmpr' className='hand' >switch employer</label>
		</td>
	</tr>
	
	*/}
	<tr key="key_tr_APP_TYPE_ID" >
	<td align='right' >Application Type:</td>
	<td align='left' >{wptapp.APP_TYPE}</td>
	</tr>
	<tr key="tr_DURATION" >
	<td align='right' >Requested Duration: </td>
	<td align='left' >{wptapp.WRK_PMT_DURATION}</td>
	</tr>
	
	<tr key="tr_ENDORSEMENT" >
	<td align='right' >Endorsement: </td>
	<td align='left' ><input value={wptapp.ENDORSE_SPOUSE+" "+wptapp.ENDORSE_CHILD}  size='15'  className="gnsbro" readOnly /></td>
	</tr>

	{
	wptapp.PRVS_WPT_ENDS!="" &&
	<tr key="tr_LATE" >
	<td align='right' >Previous WP End Date: </td>
	<td align='left' style={{color:"brown"}} >{wptapp.PRVS_WPT_ENDS}</td>
	</tr>	
	}
	
	<tr key="key_tr_VCHR_TYPE" >
	<td align='right' >Voucher Type:</td>
	<td align='left' >
		<input type='radio' name='vchrtype' id='rdlcvchr' value='LC' onClick={(e)=>{callSetVchroptions(e);}} /><label htmlFor='rdlcvchr' className="hand" >10% ADMIN RECEIPTS</label>
		<br/>
		<input type='radio' name='vchrtype' id='rdwpvchr' value='WP'  onClick={(e)=>{callSetVchroptions(e);}} /><label htmlFor='rdwpvchr' className="hand" >BALANCE RECEIPTS</label>
	</td>
	
	{/*
	
	<td align='left' id='tdapprovelc' className="hidden" >
		<input type='checkbox' id='cbapprovelc' onClick={(e)=>{updatelbrclrappdecision(e);}} /><label htmlFor='cbapprovelc' className="hand" > approve the Labour Clearance</label>
	</td>	
	*/}

	</tr>	

	<tr key="key_tr_RETURN" >
	<td align='right' ><a href="#" className="nodecor" onClick={(e)=>{backPage(e);  }}  ><img src="img/return.png" border="0" /> return to application</a></td>
	</tr>	

	

	</tbody>
	</table>
	
	{vchroptions.vchrtype!="" && <>
	<div align='center' className="vouchersuserprompt" >
	{userprompt.msg}
	</div>
	
		{!dowait.show &&
		<table align='center' className='customers' style={{width:"65%"}} >
		<thead>
		<tr>
			<th key='th1' >acc code</th>
			<th key='th3' >amount to be paid</th>
			<th key='th4' >account description</th>
			<th key='th5' >updated by</th>
			<th key='th6' >updated</th>
		</tr>
		</thead>
		<tbody>
			{vchroptions.vchrtype=='LC' && tbludaklc.length>0 && tbludaklc}
			{vchroptions.vchrtype=='WP' && tbludakwp.length>0 && tbludakwp}
		</tbody>
		</table>
		}
	</>
	}
	
	
	{/*vchroptions.vchrtype=='WP' && tbludakwp.length>0 && <>
	<table align='center' className='customers' style={{width:"65%", marginTop:"24px"}} >
	<thead>
	<tr>
		<th>acc code</th>
		<th>amount to be paid</th>
		<th>account description</th>
		<th>updated by</th>
		<th>updated</th>
	</tr>
	</thead>
	<tbody>
		{tbludakwp}
	</tbody>
	</table></>*/}	

<p align='center' >  
		
		{dowait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
		{
		!dowait.show && 
		<input type="button" id='btnsavevchrchanges' className="button" value="save changes" onClick={(e)=>{ savechanges(); }}  />
		}
		{
			/*
		&nbsp;&nbsp;&nbsp;
		<input size='4' readOnly className='gnsbro' title='amount without voucher no.' defaultValue={udak[0]?.amttodo} />
			*/
			
		}		
		&nbsp;&nbsp;&nbsp;
		{!dowait.show && udak[0]?.AMT_WITHOUT_DOC_NO>0 && vchroptions.vchrtype!='' &&  
		<>
		<a href='#' onClick={(e)=>{clearwptappudak(e);}} id="btnclearvchrtable"  className="nodecor" ><img src='img/noicon.png' border='0' /> clear the table</a>
		&nbsp;&nbsp;&nbsp;&nbsp;
		<input type="button" id='btinsertprepdoc' className="button" value="create payment vouchers" onClick={(e)=>{ getprepinsertdoc(e);  }}  />
		</>
		}
		
</p>  
{/*onKeyUp={(e)=>{setEmail({MESSAGE:''});}}*/}
	<div className="modalsm">
		<div className="modalsm-content">
			<span className="close-button">&times;</span>
			<div align='center' id='modalsmtext' >
	
			</div>
		</div>
	</div>


<div id="snackbar">&nbsp;</div>
    </>
  );
  


};


export default RenderWpForm;